import Vue from 'vue';
import store from 'store';
import select from 'dom-select';
import { mapActions, mapState } from 'vuex';
import cartData from '../../assets/js/mixins/cart-data';
import { buildItemTrackingData, getSingleCartItemData } from 'lib/tracking';
import datalayer from 'lib/datalayer';

export default (el) =>
  new Vue({
    el,
    store,
    name: 'Header Cart Icon',
    mixins: [cartData],
    watch: {
      open(isOpen) {
        if (isOpen && !this.cartInProgress) {
          this.sendViewEvent();
        }
      },
      async 'cart.items'(items) {
        await this.$nextTick(); // Wait for Vue to update the DOM
        if (!this.cartInProgress) {
          this.sendViewEvent();
        }
      }
    },
    computed: {
      ...mapState('global', ['cart']),
      ...mapState('cart', ['productsData', 'open', 'cartInProgress']),
      itemCount() {
        const cartItems = this.cart.items || [];
        const count = cartItems.reduce((total, item) => {
          total += item.quantity;
          return total;
        }, 0);
        return count;
      },
      itemCountText() {
        return `Your bag - ${this.itemCount} items`;
      },
    },
    methods: {
      ...mapActions('cart', ['toggleCart']),
      toggle() {
        this.toggleCart();
        window.__GLOBAL__.cartElTrigger = this.$el?.id;
      },
      sendViewEvent() {
        const _this = this;

        setTimeout(function() {
          const items = _this.cartItems.map((item) => {
            const data = buildItemTrackingData(item, item.quantity, {});
            const itemData = getSingleCartItemData(item);
            const payload = {
              ...data,
              ...itemData,
              price: itemData.price,
              discount: itemData.discount
            };
            return payload;
          });
  
          const data = {
            ecommerce: {
              currency: window.Shopify.currency.active,
              value: _this.cart.total_price / 100,
              items,
            },
          };
  
          datalayer.dataLayerPush('view_cart', data);
        }, 1000);
      },
    },
  });
